import type {
  CoachingGoal,
  CoachingGoalMilestone,
  CoachingGoalReflection,
  CoachingPlan,
} from '@efdigital/ll-addon-data';
import { queryCoachingGoalMilestonesByPlan } from '@efdigital/ll-xceed-v2/data/builders/coaching/coaching-goal-milestones';
import { queryCoachingGoalReflectionsByPlan } from '@efdigital/ll-xceed-v2/data/builders/coaching/coaching-goal-reflections';
import { queryCoachingGoalsByPlan } from '@efdigital/ll-xceed-v2/data/builders/coaching/coaching-goals';
import type { CoachingCoacheeCohortModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export type CoachingCoacheeCohortGoalsModel = CoachingCoacheeCohortModel & {
  goals: CoachingGoal[];
  milestones: CoachingGoalMilestone[];
  reflections: CoachingGoalReflection[];
  defaultPlan: CoachingPlan | null;
  ownerUserId: string;
};

export default class CoachingCoacheeCohortGoalsRoute extends Route<CoachingCoacheeCohortGoalsModel> {
  @service declare store: Store;

  async model(): Promise<CoachingCoacheeCohortGoalsModel> {
    const parent = this.modelFor(
      'coaching.coachee.cohort'
    ) as CoachingCoacheeCohortModel;

    const [goalsPage, milestonesPage, reflectionsPage] = parent.coachingPlan
      ? await Promise.all([
          this.store.request(queryCoachingGoalsByPlan(parent.coachingPlan.id!)),
          this.store.request(
            queryCoachingGoalMilestonesByPlan(parent.coachingPlan.id!)
          ),
          this.store.request(
            queryCoachingGoalReflectionsByPlan(parent.coachingPlan.id!)
          ),
        ])
      : [null, null, null];

    return {
      ...parent,
      goals: goalsPage?.content.data ?? [],
      milestones: milestonesPage?.content.data ?? [],
      reflections: reflectionsPage?.content.data ?? [],
      defaultPlan: parent.coachingPlan,
      ownerUserId: parent.coachingPlan?.user ?? '',
    };
  }
}
